import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import IgnitionStory from "../../../containers/dashboards/ignitionStory";
class DashboardStory extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.story" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <Row>
          <Colxx xl="8" lg="8" md="12">
              <IgnitionStory history={this.props.history} />
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}
export default DashboardStory;
